import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddonsImportComponent } from './addons-import.component';

const routes: Routes = [
  { path: 'addons-import', component: AddonsImportComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AddonsImportRoutingModule { }
